<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="eventForm" v-model="formValid" validate-on="input">
        <v-container>
          <v-row class="pa-2">
            <v-col cols="12">
              <h4 class="text-h6">Informationen</h4>
              <v-text-field
                v-model="name"
                bg-color="accent"
                variant="filled"
                label="Name der Veranstaltung*"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <ChooseFile
                :tenant-id="tenantId"
                v-model="teaserImage"
                background-color="accent"
                label="Titelbild der Veranstaltung"
                images-only
                forced-subdirectory="events"
              ></ChooseFile>
            </v-col>

            <v-col cols="12">
              <Tiptap label="Kurzbeschreibung" v-model="teaserText"></Tiptap>
            </v-col>

            <v-col cols="12">
              <Tiptap label="Beschreibung" v-model="description"></Tiptap>
            </v-col>
            <v-col cols="12" md="6">
              <v-combobox
                v-if="isInstanceOwner || isTenantOwner"
                v-model="eventTags"
                :items="api.tags"
                label="Tags"
                hide-selected
                no-data-text="Keine Tags angelegt"
                multiple
                bg-color="accent"
                clearable
                chips
                variant="filled"
              >
                <template v-slot:chip="{ attrs, item, select, selected }">
                  <v-chip
                    variant="flat"
                    v-bind="attrs"
                    :model-value="selected"
                    closable
                    color="secondary"
                    @click="select"
                    @click:close="removeTags(item?.title)"
                  >
                    <span>{{ item?.title }}</span>
                  </v-chip>
                </template>
              </v-combobox>
              <v-select
                v-else
                v-model="eventTags"
                :items="api.tags"
                label="Tags"
                hide-selected
                no-data-text="Keine Tags angelegt"
                multiple
                bg-color="accent"
                clearable
                chips
                variant="filled"
              >
                <template v-slot:chip="{ attrs, item, select, selected }">
                  <v-chip
                    variant="flat"
                    v-bind="attrs"
                    :model-value="selected"
                    closable
                    color="secondary"
                    @click="select"
                    @click:close="removeTags(item?.title)"
                  >
                    <span>{{ item?.title }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-combobox
                v-if="isInstanceOwner || isTenantOwner"
                v-model="eventFlags"
                :items="api.flags"
                label="Flags"
                no-data-text="Keine Flags angelegt"
                bg-color="accent"
                multiple
                variant="filled"
                hide-selected
                clearable
                chips
              >
                <template v-slot:chip="{ attrs, item, select, selected }">
                  <v-chip
                    variant="flat"
                    v-bind="attrs"
                    :model-value="selected"
                    closable
                    color="secondary"
                    @click="select"
                    @click:close="removeFlags(item?.title)"
                  >
                    <span>{{ item?.title }}</span>
                  </v-chip>
                </template>
              </v-combobox>
              <v-select
                v-else
                v-model="eventFlags"
                :items="api.flags"
                label="Flags"
                no-data-text="Keine Flags angelegt"
                bg-color="accent"
                multiple
                variant="filled"
                hide-selected
                clearable
                chips
              >
                <template v-slot:chip="{ attrs, item, select, selected }">
                  <v-chip
                    variant="flat"
                    v-bind="attrs"
                    :model-value="selected"
                    closable
                    color="secondary"
                    @click="select"
                    @click:close="removeFlags(item?.title)"
                  >
                    <span>{{ item?.title }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12">
              <h4 class="text-h6">Zeitraum</h4>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                variant="filled"
                v-model="startDate"
                bg-color="accent"
                label="Startdatum*"
                type="date"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                variant="filled"
                :disabled="!startDate"
                v-model="startTime"
                bg-color="accent"
                label="Startuhrzeit*"
                type="time"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                variant="filled"
                v-model="endDate"
                bg-color="accent"
                label="Enddatum*"
                type="date"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                variant="filled"
                v-model="endTime"
                :disabled="!endDate"
                bg-color="accent"
                label="Enduhrzeit*"
                type="time"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="text-subtitle-2">*Pflichtfelder</v-col>
          </v-row>
        </v-container>
        <Pager :invalid="!formValid" />
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Pager from "@/components/Events/Form/Pager";
import ApiEventService from "@/services/api/ApiEventService";
import Tiptap from "@/components/Tiptap";
import ChooseFile from "@/components/Files/ChooseFile.vue";

export default {
  data() {
    return {
      formValid: false,
      api: {
        tags: [],
        flags: [],
      },
      rules: {
        required: (value) => !!value || "Pflichtfeld",
      },
    };
  },
  components: {
    ChooseFile,
    Pager,
    Tiptap,
  },
  methods: {
    ...mapActions({
      updateValue: "events/updateForm",
    }),
    removeFlags(item) {
      this.eventFlags.splice(this.eventFlags.indexOf(item), 1);
    },
    removeTags(item) {
      this.eventTags.splice(this.eventTags.indexOf(item), 1);
    },
    fetchTags() {
      ApiEventService.getTags()
        .then((response) => {
          this.api.tags = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchFlags() {
      ApiEventService.getFlags()
        .then((response) => {
          this.api.flags = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapGetters({
      tenantId: "tenants/currentTenantId",
      isInstanceOwner: "user/isInstanceOwner",
      isTenantOwner: "user/isTenantOwner",
    }),
    name: {
      get() {
        return this.$store.state.events.form.information.name;
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "name",
          value: value,
        });
      },
    },
    teaserText: {
      get() {
        return this.$store.state.events.form.information.teaserText;
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "teaserText",
          value: value,
        });
      },
    },
    description: {
      get() {
        return this.$store.state.events.form.information.description;
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "description",
          value: value,
        });
      },
    },
    teaserImage: {
      get() {
        return this.$store.state.events.form.information.teaserImage;
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "teaserImage",
          value: value,
        });
      },
    },
    eventFlags: {
      get() {
        return this.$store.state.events.form.information.flags;
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "flags",
          value: value,
        });
      },
    },
    eventTags: {
      get() {
        return this.$store.state.events.form.information.tags;
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "tags",
          value: value,
        });
      },
    },
    startDate: {
      get() {
        return this.$store.state.events.form.information.startDate?.split(
          "T"
        )[0];
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "startDate",
          value: value,
        });
      },
    },
    startTime: {
      get() {
        return this.$store.state.events.form.information.startTime;
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "startTime",
          value: value,
        });
      },
    },
    endDate: {
      get() {
        return this.$store.state.events.form.information.endDate?.split("T")[0];
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "endDate",
          value: value,
        });
      },
    },
    endTime: {
      get() {
        return this.$store.state.events.form.information.endTime;
      },
      set(value) {
        this.updateValue({
          parent: "information",
          field: "endTime",
          value: value,
        });
      },
    },
    ...mapGetters({
      form: "events/form",
    }),
  },
  created() {
    this.fetchTags();
    this.fetchFlags();
  },
};
</script>

<style scoped></style>
